import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { Condominio, CreateCondominioRequest } from '@condo/contracts';
import { ApiRoutes } from '@condo/contracts';
import { api } from '@/lib/api/client';
import { queryKeys } from '@/lib/api/query-keys';

interface CondominiosListResponse {
  items: Condominio[];
}

export function useCondominios() {
  return useQuery({
    queryKey: queryKeys.condominios(),
    queryFn: () => api.get<CondominiosListResponse>(ApiRoutes.condominios),
  });
}

export function useCondominio(id: string | undefined) {
  return useQuery({
    queryKey: queryKeys.condominio(id ?? ''),
    queryFn: () => api.get<Condominio>(ApiRoutes.condominioById(id!)),
    enabled: !!id,
  });
}

export function useCreateCondominio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: CreateCondominioRequest) =>
      api.post<Condominio, CreateCondominioRequest>(ApiRoutes.condominios, req),
    onSuccess: (created) => {
      qc.invalidateQueries({ queryKey: queryKeys.condominios() });
      qc.setQueryData(queryKeys.condominio(created.id), created);
    },
  });
}
